export default __webpack_public_path__ + "static/lalibrairie-c-mobile@2x-f3f5ad2151348303a528e04cb4a6223e.jpg";